import { SpanStatusCode, trace } from "@opentelemetry/api";
import { ErrorInfo } from "react";

const tracer = trace.getTracer("error-handling");

export const logError = (error: any, errorInfo?: ErrorInfo) => {
    // @ts-expect-error - ts does not know about Sentry
    window.Sentry?.captureException(error);
    // @ts-expect-error - ts does not know newrelic
    window.newrelic?.noticeError(error, { componentStack: errorInfo?.componentStack });
    reportOTELError(error, errorInfo);
}

const reportOTELError = (error: any, errorInfo?: ErrorInfo) => {
    const activeSpan = trace.getActiveSpan();
    const span = activeSpan || tracer.startSpan("React.ErrorBoundary");
    span.recordException(error);
    span.setStatus({ code: SpanStatusCode.ERROR });
    span.setAttribute("error", true);
    span.setAttribute("error.message", error.message);
    span.setAttribute("error.stack", error.stack || "");
    span.setAttribute("error.componentStack", errorInfo?.componentStack || "");
    if (!activeSpan) {
        span.end();
    }
};
